export default (element) => {
  const cta = element.querySelector('[data-section-cta]');
  const icon = cta.querySelector('[data-section-cta-icon]');

  if (!cta || !icon) return;
  cta.addEventListener('click', () => icon.classList.toggle('rotate-180'));
};
